import React from 'react';
import { Theme } from './theme';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { spaceOptions } from './utils';

const getLetterBackground = (letter = '') => {
  const position = Math.floor((letter.toLowerCase().charCodeAt(0) - 97) / 5);
  return colorPalette[Math.min(4, position)];
};

const colorPalette = ['#ff9a35', '#8bc24b', '#6797ea', '#737887', '#4dc0cf'];
export const fallbackSize = size => {
  return size !== 0 ? size : 50;
};

export const backgroundSet = (image, letter) => {
  return image.length > 1
    ? `background-image: url('${image}')`
    : `background-color: ${getLetterBackground(letter)}`;
};

export const fallbackFontSize = size => {
  return size !== 0 ? size * 0.4 : 20;
};

export const labelSize = size => {
  return fallbackSize(size) * 0.2;
};

const AvatarWrapper = styled.div`
  width: ${props => fallbackSize(props.size)}px;
  min-height: ${props => fallbackSize(props.size)}px;
  display: inline-block;
  vertical-align: top;
  text-align: center;

  .fallback-letter {
    padding-top: 30%;
    text-transform: uppercase;
    color: white;
    display: block;
    line-height: 1;
    font-size: ${props => fallbackFontSize(props.size)}px;
  }
  .background {
    width: ${props => fallbackSize(props.size)}px;
    height: ${props => fallbackSize(props.size)}px;
    display: block;
    background-size: cover;
    border-radius: 50%;
    ${props => backgroundSet(props.image, props.letter)};
  }
  .label {
    font-size: ${props => labelSize(props.size)}px;
    letter-spacing: 1px;
    line-height: 1.8;
    color: #fff;
    background-color: ${Theme.primary};
    border-radius: ${props => labelSize(props.size)}px;
    padding: 0 ${props => fallbackSize(props.size) * 0.08}px;
    display: block;
    margin: ${props => 0 - fallbackSize(props.size) * 0.18}px auto 0;
    text-transform: uppercase;
    max-width: 85%;
  }
  ${spaceOptions};
`;

export const Avatar = ({ image, letter, hired, ...rest }) => (
  <AvatarWrapper image={image} letter={letter} {...rest} hired={hired}>
    <span className="background">
      {image ? false : <span className="fallback-letter">{letter.slice(0, 1)}</span>}
    </span>
    {hired ? <span className="label"> Hired </span> : false}
  </AvatarWrapper>
);

Avatar.defaultProps = {
  image: '',
  letter: '',
  size: 0
};

Avatar.propTypes = {
  hired: PropTypes.bool,
  image: PropTypes.string,
  letter: PropTypes.string,
  size: PropTypes.number
};

Avatar.displayName = 'Avatar';
